import script from "./PageMappingCategoryUrssafBrandListDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageMappingCategoryUrssafBrandListDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PageMappingCategoryUrssafBrandListDetail.vue?vue&type=style&index=0&id=d978519c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d978519c"]])

export default __exports__